import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const TinCell = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

export const NameCell = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

export const ControlRoot = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const SearchBox = styled.div`
    min-width: 350px;
    max-width: 700px;
    width: 100%;
`;
